import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loading from '../components/Loading';
import { AuthContext } from '../providers/Auth';
import Log from '../services/Log';

const SkipRoute = () => {
  const { data } = useContext(AuthContext);

  Log.message(`Skip Route - ${data.loading}, ${JSON.stringify(data.user)}`);

  if (data.loading) {
    return <Loading />;
  }

  return data.user !== null ? <Navigate to="/account" /> : <Outlet />;
};

export default SkipRoute;
